<template>
<div>
<v-card style="height: 100%; width: 100%;">
  <v-toolbar dense dark >
    <v-toolbar-title  >Sales Pipeline</v-toolbar-title>
    <v-spacer></v-spacer>
      <v-btn  rounded color="brown" dark  :class="active == 0 ? 'highlight' : 'sbtn'" @click.native="active = 0">Prospecting</v-btn>
      <v-btn dark color="orange" :class="active == 1 ? 'highlight' : 'sbtn'" @click.native="active = 1">Qualifying</v-btn>
      <v-btn dark color="purple" :class="active == 2 ? 'highlight' : 'sbtn'" @click.native="active = 2">Engaging</v-btn>
      <v-btn dark color="green" :class="active == 3 ? 'highlight' : 'sbtn'" @click.native="active = 3">Closing</v-btn>
      <v-btn dark color="blue" :class="active == 4 ? 'highlight' : 'sbtn'" @click.native="active = 4">?</v-btn>
  </v-toolbar>
  <v-card>
    <SalesPipeline1 v-if="active == 0" />
    <SalesPipeline2 v-if="active == 1" />
    <SalesPipeline3 v-if="active == 2" />
    <SalesPipeline4 v-if="active == 3" />
    <Help v-if="active == 4" />
  </v-card>
</v-card>
</div>
</template>

<script>
import SalesPipeline1 from '@/components/CRM/SalesPipeline1'
import SalesPipeline2 from '@/components/CRM/SalesPipeline2'
import SalesPipeline3 from '@/components/CRM/SalesPipeline3'
import SalesPipeline4 from '@/components/CRM/SalesPipeline4'
import Help from '@/components/CRM/help'
export default {
  components: {
    SalesPipeline1,
    SalesPipeline2,
    SalesPipeline3,
    SalesPipeline4,
    Help
  },
  data: () =>({
    active: 0
  }),
  watch: {
    active (val) {
      console.log('tab active: ', val)
    }
  }
}
</script>
<style scoped>
.highlight {
  margin: 10px;
  border-radius: 15px;
  font-weight: bold;
  text-decoration: underline;
  text-underline-position:auto;
}
.sbtn {
  margin: 10px;
  border-radius: 15px;
}
</style>